import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { Button } from "antd";
import AWS from "aws-sdk";

import Swal from "sweetalert2";

import partnersApi from "../../../apis/Partners.api";
import { setLoading } from "../../../redux/store/common/commonDuck";

import EditDefaultComponent from "./EditDefaultComponent";
import EditDefaultProductComponent from "./EditDefaultProductComponent";
import EditDefaultVideoComponent from "./EditDefaultVideoComponent";

AWS.config.update({
	accessKeyId: process.env.REACT_APP_S3_ACCESSKEYID,
	secretAccessKey: process.env.REACT_APP_S3_SECRETACCESSKEY,
	region: process.env.REACT_APP_S3_REGION,
});

const s3 = new AWS.S3();

const EditCategoryBody = ({
	selectCategory,
	categoryList,
	selectKey,
	setSelectKey,
	linkList,
	setLinkList,
	productList,
	setProductList,
	getCategory,
}) => {
	const dispatch = useDispatch();
	const user = useSelector((state) => state.auth.user);
	const isLoading = useSelector((state) => state.common.loading);
	const setIsLoading = (value) => dispatch(setLoading(value));

	// console.log(!Object.keys(selectKey)?.length);
	// console.log(productList?.map((item) => ({
	//     ...item,
	//     id: item?.id === 1 ? null : item.id
	// })));

	const handleCategoryBodyDisable = (e) => {
		if (!selectKey || (!!selectKey && !Object.keys(selectKey)?.length)) {
			e.stopPropagation();
			e.preventDefault();
			const categoryBody = document.getElementsByClassName(
				"edit-channel-category-body-component"
			);
			if (categoryBody && categoryBody?.[0]) {
				Swal.fire({
					customClass: "alert-custom",
					text: "카테고리를 선택/추가해주세요.",
					confirmButtonText: "확인",
				}).then(() => {
					window.scrollTo({
						top: 0,
						behavior: "smooth",
					});
				});
			}
		}
	};

	const mainList =
		user?.id === 9 || user?.partners_id === 9
			? [
					{
						list: "ingredientList",
						// name: "성분별",
						name: "고민별",
					},
			  ]
			: [
					{
						list: "ingredientList",
						name: "성분별",
					},
					{
						list: "functionList",
						name: "고민별",
					},
					{
						list: "combinationList",
						name: "조합별",
					},
			  ];

	const [defaultList, setDefaultList] = useState({});

	useEffect(() => {
		let main = 0;
		if (selectKey?.is_hot) {
			main = 1;
		}
		if (selectKey?.is_best) {
			main = 2;
		}
		if (!selectKey?.is_hot && !selectKey?.is_best) {
			main = 0;
		}
		setDefaultList({
			...defaultList,
			// is_comment_show: selectKey?.is_comment_show ? 1 : 1,
			is_comment_show: 1,
			is_show: selectKey?.is_show ? 1 : 0,
			main_tag: main,
			explanation: selectKey?.explanation,
			relation_list: selectKey?.ingredientList,
			category_name: selectKey?.ingredient_name
				? selectKey?.ingredient_name
				: selectKey?.function_name
				? selectKey?.function_name
				: selectKey?.category_name,
			category_id: selectKey?.ingredient_id
				? selectKey?.ingredient_id
				: selectKey?.function_id
				? selectKey?.function_id
				: selectKey?.category_id,
			reason: selectKey?.reason ?? "",
		});
	}, [selectKey]);

	useEffect(() => {
		setDefaultList({});
	}, [selectCategory]);

	/**
	 * 이미지 S3 업로드
	 * @param reviewId
	 */
	const uploadToS3 = async (addObj) => {
		let id = addObj.id;
		let fileType = addObj?.photo?.type.split("/")[1] ?? addObj.img_type;
		let s3Path = `image/together/${
			user?.role === "level_1" || user?.role === "super_admin"
				? user.influencer_id
				: user?.role
		}/${id}.${fileType}`;
		// console.log(id, fileType, s3Path);
		//aws-sdk 사용
		let params = {
			Bucket: process.env.REACT_APP_S3_BUCKETNAME,
			Key: s3Path,
			Body: addObj?.photo?.file,
		};

		let res = await s3.putObject(params).promise();

		if (res.$response.httpResponse.statusCode === 200) {
			// alert("정상적으로 저장되었습니다.");
			// getInfo();
		} else {
			alert("이미지 업로드 오류");
		}
		// getProductList(selectKey);
		// setModalShow(false);
	};

	/**
	 * 저장 add/수정 edit
	 * @returns {Promise<void>}
	 */
	const submitList = async (type) => {
		let isValid = false; // true: 오류, false: 통과
		for (let i = 0; i < linkList.length; i++) {
			// 타이틀 x || 길이 === 0 // true: 오류, false: 통과
			let titleValid = !!(
				!linkList[i]?.title || linkList[i]?.title?.length === 0
			);
			// url x || https x || https://[길이 === 0] // true: 오류, false: 통과
			let urlValid = !!(
				!linkList[i]?.url ||
				!linkList[i]?.url?.includes("https") ||
				linkList[i]?.url?.split("https://")[1]?.length === 0
			);

			if (titleValid || urlValid) {
				if (!isValid) {
					isValid = true;
				}
			}
		}
		if (!defaultList?.category_name) {
			if (selectCategory !== 2) {
				if (!defaultList?.category_id) {
					if (!isValid) {
						isValid = true;
					}
				}
			} else {
				if (!isValid) {
					isValid = true;
				}
			}
		}

		if (isValid) {
			alert("해당하는 내용을 모두 입력해주세요.");
			window.scrollTo({
				top: 0,
				behavior: "smooth",
			});
		} else {
			Swal.fire({
				customClass: "alert-custom",
				text: `${type === "add" ? "저장" : "수정"}하시겠습니까?`,
				showCancelButton: true,
				confirmButtonText: "확인",
				cancelButtonText: "취소",
			}).then(async (result) => {
				if (result.isConfirmed) {
					setIsLoading(true);
					let list = [];
					for (let i = 0; i < linkList?.length; i++) {
						let linkId = linkList[i]?.id ?? null;
						let url = linkList[i]?.url;
						let listEach = {
							platform_id: url?.includes("instagram") ? 5 : 0,
							platform_name: url?.includes("instagram")
								? "instagram"
								: "Youtube",
							url: linkList[i].url,
							title: linkList[i].title,
							search_tag: linkList[i].search_tag,
						};
						if (linkId !== null) {
							listEach = { ...listEach, id: linkId };
						}
						list.push(listEach);
					}
					// 상품 우선순위
					for (let i = 0; i < productList?.length; i++) {
						productList[i].sort_order = i + 1;
						productList[i].is_best = !!productList[i].is_best;
						if (
							!!productList[i]?.front_img_src ||
							productList[i]?.id === null
						) {
							delete productList[i]?.id;
						} else productList[i].updated_by = user?.id;
					}

					let param = {
						id: selectKey?.id ?? null,
						// 기본 + 성분별
						influencer_id:
							user?.role === "level_1" || user?.role === "super_admin"
								? user?.id
								: user?.partners_id,
						category_id: selectKey?.id
							? selectKey.ingredient_id
								? selectKey.ingredient_id
								: selectKey.function_id
								? selectKey.function_id
								: selectKey.category_id
							: defaultList?.category_id
							? defaultList?.category_id
							: null,
						category_name: defaultList?.category_name,
						category_type: mainList[selectCategory].list?.replace("List", ""),
						updated_by: user.id,
						associatedVideoList: list,
						productList: productList ?? [],
						associatedFunctionList: null,
						is_show: defaultList?.is_show === 1,
						explanation: defaultList?.explanation ?? null,
						is_hot: defaultList?.main_tag === 1,
						is_best: defaultList?.main_tag === 2,
						is_comment_show: defaultList?.is_comment_show === 1,

						// 고민별
						ingredientList: defaultList?.relation_list ?? [],

						// 조합별
						category_description: null,
						reason: defaultList?.reason ?? "",
						// caution: "",
						// tag: "",
					};

					let res = { code: 0, result: {} };
					if (selectCategory === 2) {
						res = await partnersApi.createdCombinationList(param);
					} else {
						if (type === "add") {
							res = await partnersApi.createCategoryList(param);
						} else {
							res = await partnersApi.postCategoryLinkList(param);
						}
					}
					if (res.code === 200) {
						let list = res.result;
						if (selectCategory === 0) {
							for (let i = 0; i < list.length; i++) {
								let addObj = {
									...list[i],
									...productList[i],
								};
								// edit
								if (addObj.id) {
									if (addObj?.photo) {
										const rsq = await partnersApi.updateCategoryProduct({
											...addObj,
											updated_by: user?.id,
										});
										if (rsq.code === 200) {
											console.log("edit");
											uploadToS3(addObj);
										}
									} else {
										console.log("no-edit");
									}
								}
								// save
								else {
									const rsq = await partnersApi.createCategoryProduct({
										...addObj,
										created_by: user?.id,
									});
									if (rsq.code === 200) {
										console.log("save");
										uploadToS3(addObj);
									}
								}
							}
						}
						getCategory(type === "add" ? "save" : "edit");
					} else {
						alert("error: 적용이 실패되었습니다.");
						setIsLoading(false);
					}
				}
			});
		}
	};

	return (
		<div
			className={`edit-channel-category-body-component`}
			onClick={handleCategoryBodyDisable}
		>
			<div className={`body-location`}>
				<p>{mainList[selectCategory]?.name}</p>
				{selectKey?.id && (
					<img
						src={`/assets/images/channel/right-arrow.png`}
						alt={`화살표`}
						style={{
							height: "1.2em",
							width: "1.2em",
						}}
					/>
				)}
				<p>
					{selectCategory === 0
						? selectKey?.ingredient_name
						: selectCategory === 1
						? selectKey?.function_name
						: selectKey?.category_name}
				</p>
			</div>

			{/* 기본 설정 */}
			<EditDefaultComponent
				selectCategory={selectCategory}
				selectKey={selectKey}
				defaultList={defaultList}
				setDefaultList={setDefaultList}
				categoryList={categoryList}
			/>

			{/* 관련 영상 추가 */}
			<EditDefaultVideoComponent
				selectKey={selectKey}
				linkList={linkList}
				setLinkList={setLinkList}
			/>

			{/*/ 관련 영양제 /*/}
			{selectCategory !== 1 && (
				<EditDefaultProductComponent
					selectKey={selectKey}
					productList={productList}
					setProductList={setProductList}
					level={selectCategory === 0 ? "ingredient" : "combination"}
				/>
			)}

			{/* 적용하기 */}
			<div className={`edit-category-footer`}>
				<Button
					onClick={() => {
						if (selectKey?.id) {
							submitList("edit");
						} else {
							submitList("add");
						}
					}}
					loading={isLoading}
					disabled={
						!selectKey || (!!selectKey && !Object.keys(selectKey)?.length)
					}
				>
					적용하기
				</Button>
			</div>
		</div>
	);
};
export default EditCategoryBody;
